export const SHIPMENTS_SEARCH_REQUEST = 'SHIPMENT_SEARCH_REQUEST';
export const SHIPMENTS_SET_SEARCH_RESULTS = 'SHIPMENTS_SET_SEARCH_RESULTS';
export const SHIPMENTS_DOWNLOAD_DOCUMENTS_REQUEST = 'SHIPMENTS_DOWNLOAD_DOCUMENTS_REQUEST';
export const SHIPMENTS_UPDATE_STATUS = 'SHIPMENTS_UPDATE_STATUS';
